<template>
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 20C15.7466 20 20 15.7466 20 10.5C20 5.25341 15.7466 1 10.5 1C5.25341 1 1 5.25341 1 10.5C1 15.7466 5.25341 20 10.5 20ZM10.5 20C13.0909 20 13.9545 15.6818 13.9545 10.5C13.9545 5.31818 13.0909 1 10.5 1C7.90909 1 7.04545 5.31818 7.04545 10.5C7.04545 15.6818 7.90909 20 10.5 20ZM1.86364 13.9545H19.1364H1.86364ZM1.86364 7.04545H19.1364H1.86364Z"
      fill="white"
    />
    <path
      d="M1.86364 7.04545H19.1364M10.5 20C15.7466 20 20 15.7466 20 10.5C20 5.25341 15.7466 1 10.5 1C5.25341 1 1 5.25341 1 10.5C1 15.7466 5.25341 20 10.5 20ZM10.5 20C13.0909 20 13.9545 15.6818 13.9545 10.5C13.9545 5.31818 13.0909 1 10.5 1C7.90909 1 7.04545 5.31818 7.04545 10.5C7.04545 15.6818 7.90909 20 10.5 20ZM1.86364 13.9545H19.1364H1.86364Z"
      stroke="url(#paint0_linear_1_2554)"
      stroke-width="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_2554"
        x1="10.5"
        y1="1"
        x2="10.5"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
